<template>
  <div class="about">
    <div class="col-md-12">
      <h1 class="mb-4">Frequently asked questions</h1>

      <h4>Why does UkeAbility exist?</h4>
      <p class="mb-4">
        I wanted to discover new songs, using chords I already knew. Also, I
        wanted to better use the terrific playalong videos that are available
        for the ukulele.
      </p>

      <h4>What ukulele should I use to play these chords?</h4>
      <p class="mb-4">
        The chord diagrams are for instruments tuned in the key of C. C is the
        standard tuning of soprano, concert and tenor ukuleles.
      </p>

      <h4>Didn't this site exist before, but just for books?</h4>
      <p class="mb-4">
        Yes. Originally the site (version 1) existed for books. That version is
        <b-link href="https://v1.ukeability.org">still available here</b-link>.
        I hope to migrate the book data over to the new site soon.
      </p>

      <h4>Why don't you have more videos available?</h4>
      <p class="mb-4">
        I add videos as time comes available. If you'd like to help out by
        suggesting a video,
        <b-link
          :to="{ name: 'public-submit' }"
          v-text="'please submit a link here'"
        />.
      </p>

      <h4>
        Do you have any connection to the books, their authors or the book
        publishers?
      </h4>
      <p class="mb-4">
        No, I'm just a big fan who would like to see people make the most of the
        books. This is an educational resourse for myself and others.
      </p>

      <h4>What's your favorite song to play?</h4>
      <p class="mb-4">Ob-La-Di, Ob-La-Da, The Daily Ukulele book, page 174</p>

      <h4>How do you pay for the hosting of this site?</h4>
      <p class="mb-4">
        Out of my own pocket. This a gift to the wonderful world-wide ukulele
        community. I use this site myself to help me find songs to play. I hope
        you'll find it useful as well.
      </p>

      <h4>
        Do I need an account? Where are my chords and songs favorites saved?
      </h4>
      <p class="mb-4">
        No account is needed. All of your data is stored in your browser's local
        storage.
      </p>

      <!--
      <h4>How do I create an free account?</h4>
      <p class="mb-4">
        Sign up on the registration page. UkeAbility doesn't have passwords.
        Enter your email address below and you'll receive a link to sign in
        again.
      </p>
    -->

      <h4>What tech is used on the site?</h4>
      <p class="mb-4">
        VueJS, Django, Zappa, and Bootstrap. The site is hosted using AWS Lambda
        and RDS.
      </p>

      <h1 class="mb-4">Contact</h1>
      <p>
        You can reach me at
        <a href="mailto:joe.weiss@gmail.com">joe.weiss@gmail.com</a>.
      </p>

      <!-- Begin MailChimp Signup Form -->

      <div class="mt-5">
        <form
          id="mc-embedded-subscribe-form"
          action="https://tungite.us17.list-manage.com/subscribe/post?u=eec0d207c736ffddcf22c89d2&amp;id=b419cab12c"
          method="post"
          name="mc-embedded-subscribe-form"
          class="validate"
          target="_blank"
          novalidate=""
        >
          <div id="mc_embed_signup_scroll">
            <h4>Subscribe to our update list</h4>
            <div class="mc-field-group form-group">
              <label for="mce-EMAIL">Email Address </label>
              <input
                id="mce-EMAIL"
                type="email"
                value=""
                name="EMAIL"
                class="required email form-control col-md-4"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
            </div>
            <div id="mce-responses" class="clear">
              <div
                id="mce-error-response"
                class="response"
                style="display:none"
              />
              <div
                id="mce-success-response"
                class="response"
                style="display:none"
              />
            </div>
            <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
            <div style="position: absolute; left: -5000px;" aria-hidden="true">
              <input
                type="text"
                name="b_eec0d207c736ffddcf22c89d2_b419cab12c"
                tabindex="-1"
                value=""
              />
            </div>
            <div class="clear">
              <input
                id="mc-embedded-subscribe"
                type="submit"
                value="Subscribe"
                name="subscribe"
                class="btn btn-primary"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="debug">
      <b-btn
        v-if="debug"
        class="mr-1"
        @click="$store.dispatch('clearLocalStorage')"
      >
        Clear user preferences
      </b-btn>
      <b-btn class="mr-1" @click="loadLocalStorage">
        Load local storage
      </b-btn>
      <ObjectPrint :data="localData" />
    </div>
  </div>
</template>

<script>
import Storage from "store2";

export default {
  data() {
    return {
      localData: {}
    };
  },

  computed: {
    debug() {
      return "debug" in this.$route.query;
    }
  },
  methods: {
    loadLocalStorage() {
      console.log(Storage());
      this.localData = Storage();
    }
  }
};
</script>

<style lang="css" scoped>
h4{
  font-weight: normal;
  }
</style>
